import { render, staticRenderFns } from "./career-courseware-detail.vue?vue&type=template&id=05062d04&scoped=true&"
import script from "./career-courseware-detail.vue?vue&type=script&lang=js&"
export * from "./career-courseware-detail.vue?vue&type=script&lang=js&"
import style0 from "./career-courseware-detail.vue?vue&type=style&index=0&id=05062d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05062d04",
  null
  
)

export default component.exports